import { IJsonResponseModel } from 'app/store/global/json-response.model';

// snack bar notification configuration
export const snackBarConfig = (
  data: Pick<IJsonResponseModel<[]>, 'success' | 'message'>
) => {
  return {
    data,
    duration: 6000,
  };
};
